import { Flex, Text } from '@chakra-ui/react'

import DoneCheckIcon from '@/ui/assets/DoneCheckIcon'

import { StepStatus } from '../types/StepStatus'

export function Step({
  index,
  name,
  status,
  onClick
}: {
  index: number
  name: string
  status: StepStatus
  onClick: () => void
}) {
  return (
    <Flex
      borderRadius={'full'}
      border={'solid 1px'}
      borderColor={
        status === 'CURRENT' ? 'custom.blue.darker' : 'custom.gray.500'
      }
      alignItems={'center'}
      justifyContent={'center'}
      gap={'2'}
      p={'1'}
      cursor={status === 'COMPLETE' ? 'pointer' : undefined}
      onClick={() => status === 'COMPLETE' && onClick()}
    >
      <Text
        fontSize={'0.75rem'}
        fontWeight={'400'}
        color={status === 'CURRENT' ? 'custom.blue.darker' : 'custom.gray.500'}
        borderRadius={'full'}
        border={'solid 1px'}
        borderColor={
          status === 'COMPLETE'
            ? 'custom.system.success'
            : status === 'CURRENT'
              ? 'custom.blue.darker'
              : 'custom.gray.500'
        }
        bgColor={status === 'COMPLETE' ? 'custom.system.success' : undefined}
        display={'inline-flex'}
        w={'1.5em'}
        h={'1.5em'}
        alignItems={'center'}
        justifyContent={'center'}
      >
        {status === 'COMPLETE' ? <DoneCheckIcon color={'white'} /> : index}
      </Text>
      <Text
        fontSize={'0.875rem'}
        fontWeight={'500'}
        color={status === 'CURRENT' ? 'custom.blue.darker' : 'custom.gray.500'}
        w={'max-content'}
      >
        {name}
      </Text>
    </Flex>
  )
}
